import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/newbiePack.ts
const newbiePackStateSchema = z.enum([
	"not_eligible",
	"not_triggered",
	"active_48h",
	"active_persistent",
	"completed"
]);
const newbiePackTierSchema = z.object({
	tierCode: z.string(),
	itemId: z.string(),
	purchased: z.boolean(),
	purchasable: z.boolean()
});
const newbiePackSnapshotSchema = z.object({
	state: newbiePackStateSchema,
	triggerAt: z.iso.datetime().nullable(),
	hoursSinceTrigger: z.number().nullable(),
	ahaShownAt: z.iso.datetime().nullable(),
	tiers: z.array(newbiePackTierSchema),
	visibleEntryPoints: z.array(z.string()),
	promotionSuppression: z.boolean()
});
const newbiePackMarkAhaShownSchema = z.object({
	recorded: z.boolean(),
	alreadyShown: z.boolean(),
	ahaShownAt: z.iso.datetime().nullable()
});
const uaNewbiePackContract = oc.prefix("/payment-events/newbie-pack").tag("PaymentEvents").router({
	getSnapshot: oc.route({
		method: "GET",
		path: "/snapshot",
		summary: "Get newbie-pack campaign snapshot for current user"
	}).output(newbiePackSnapshotSchema).errors({ UNAUTHORIZED: {
		status: 401,
		message: "Authentication required"
	} }),
	markAhaShown: oc.route({
		method: "POST",
		path: "/aha-shown",
		summary: "Mark newbie-pack Aha popup as shown for current user account"
	}).output(newbiePackMarkAhaShownSchema).errors({ UNAUTHORIZED: {
		status: 401,
		message: "Authentication required"
	} })
});
//#endregion
export { uaNewbiePackContract };
